import { Field } from './field'

export interface FieldGroupInterface {
  domain?: string
  fields?: Field[]
  name: string
  weight?: number
  sortable?: boolean
  editable?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class FieldGroup implements FieldGroupInterface {
  domain?: string
  fields?: Field[]
  name: string
  weight?: number
  sortable?: boolean
  editable?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: FieldGroupInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      domain: _domain,
      fields: _fields,
      name: _name,
      weight: _weight,
      sortable: _sortable,
      editable: _editable,
      id: _id,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.domain = _domain
    this.fields = _fields ? _fields.map((i) => new Field(i)) : _fields
    this.name = _name
    this.weight = _weight
    this.sortable = _sortable
    this.editable = _editable
    this.id = _id
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
